import "./lineindicator.scss";

const LineIndicator = () => {
    return(
        <div className="Line-Indicator"></div>
    );
}

export default LineIndicator;